<template>
  <div
    ref="capture"
    :id="isFakeRendering ? 'main_html'+renderingOrder:'main_html'"
    :style="getHTMLStyle"
    class="html-container canvas-main-html-container"
    @dblclick.stop="onCanvasDoubleClick"
    @click.stop="onCanvasClick"
  >
    <component
      v-for="(object,index) in getContent"
      :is="object.type+'-object'"
      :element-index="index"
      :data-pageindex = "object.PageIndex"
      :key="object.Id"
      :data="object"
      :object-props="object"
      :scale="zoom"
      :is-fake-rendering="isFakeRendering"
      :display-controls="true"
    />


  </div>
</template>
<script>
/* eslint-disable max-len */
import {
  Text, Image as ImageObj, Path, Video,
} from '@/components/CanvasShapes';
import EventBus from '@/EventBus';
import canvasTextFunctions from '@/components/Canvas/mixins/canvasTextFunctions';
import canvasSelectionManager from '@/components/Canvas/mixins/canvasSelectionManager';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes'; // TDOD: Change to @/
import canvasImageFunctions from '@/components/Canvas/mixins/canvasImageFunctions';
import canvasShapeFunctions from '@/components/Canvas/mixins/canvasShapeFunctions';
import Vue from 'vue';
import _ from 'lodash';
import { uuid } from 'vue-uuid';
import canvasVideoFunctions from './mixins/canvasVideoFunctions';


export default {

  name:       'Canvas',
  components: {
    'text-object':  Text,
    'shape-object': Path,
    'image-object': ImageObj,
    'video-object': Video,

  },
  mixins: [canvasTextFunctions, canvasSelectionManager, canvasImageFunctions, canvasShapeFunctions, canvasVideoFunctions],
  props:  {
    uniqueId: {
      type:    String,
      default: '-1',
    },
    width:              Number,
    height:             Number,
    scale:              Number,
    activePage:         Number,
    contentList:        { Object, Array },
    baseImage:          String,
    productCrop:        { Object },
    productScale:       Array,
    isGrayScaleOn:      Boolean,
    isAlignmentGuideOn: Boolean,
    isFakeRendering:    Boolean,
    renderingOrder:     Number,
  },
  data() {
    return {
      isObjectSelected:           false,
      container:                  null,
      moveableObj:                { target: null },
      handlerTriggeredCount:      0,
      selectO:                    null,
      zoom:                       1,
      targets:                    [],
      activeObject:               null,
      activeEditor:               null,
      objectList:                 this.contentList,
      isMounted:                  false, // used in canvas panel
      isProductChangedByUndoRedo: false, // used in undo redo manager
      allTextEditorList:          {},
      calcRatio:                  0.3,
      lastGroupRotation:          0,
    };
  },
  computed: {
    getIsAlignmentGuideOn() {
      return this.isAlignmentGuideOn;
    },
    getScale() {
      return `scale( ${this.zoom})`;
    },
    getWidth() {
      return `${this.width}px`;
    },
    getHeight() {
      return `${this.height}px`;
    },
    getContent() {
      return this.objectList;
    },
    getHtmlStringFromActiveObject() {
      return this.activeObject ? this.activeObject.Value : null;
    },
    geteditorFromContentList(index) {
      return this.objectList[index].editor;
    },
    getTranslate() {
      const { AllowCropping, XCrop, YCrop } = this.productCrop;
      return AllowCropping ? `translate(${-parseFloat(XCrop)}px,${-parseFloat(YCrop)}px)` : '';
    },
    getElementWrapperStyle() {
      if (!this.productScale || !this.productScale[0] || !this.productScale[1]) {
        return 'scale(1,1)';
      }
      return {
        transform:       `scale(${this.productScale[0]},${this.productScale[1]})`,
        transformOrigin: 'top left',
      };
    },
    getHTMLStyle() {
      // ${this.getTranslate}
      const {
        AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop,
      } = this.productCrop;
      const scaleRatio = this.scale / 100;
      const transform  = `scale(${scaleRatio}) `;
      const newStyle   = {
        transform,
        width:            `${this.width}px`,
        height:           `${this.height}px`,
        backgroundColor:  '#ffffff',
        overflow:         (this.activeObject && this.activeObject.isEditorEnable) ? '' : 'hidden',
        // pageBreakAfter:  'always',
        backgroundImage:  `url(${this.baseImage})`,
        backgroundRepeat: 'no-repeat',
        filter:           this.isGrayScaleOn ? 'grayscale(1)' : 'grayscale(0)',
        marginLeft:       AllowCropping ? `${-parseFloat(XCrop * scaleRatio)}px` : '0px',
        marginTop:        AllowCropping ? `${-parseFloat(YCrop * scaleRatio)}px` : '0px',
        backgroundSize:   `${AllowCropping ? this.width + parseFloat(XCrop) : this.width}px ${AllowCropping ? this.height + parseFloat(YCrop) : this.height}px`,
      };
      return newStyle;
    },

  },
  watch: {
    getContent: {
      deep: true,
      handler() {
        this.updateElementSnapping();
      },
    },
    activeObject: {
      handler(newObject) {
        this.updateMoveableTargets(newObject);
      },
    },
    targets2: {
      handler(newTargets) {
        const { target } =  this.moveableObj;

        if (target && target.length > 0) {
          const object =   this.objectList[parseInt(target[0].dataset.elementindex, 10)];
          object && object.type === 'text' && (object.Value = object.modifiedHtml);
        }
        this.moveableObj.target = [];
        if (newTargets.length === 0) {
          this.moveableObj.target = newTargets;
        } else {
          const object = this.objectList[parseInt(newTargets[0].dataset.elementindex, 10)];
          object.IsVisible && (this.moveableObj.target = newTargets);
        }
        if (newTargets && newTargets.length > 0 && newTargets[0].dataset.type === 'text') {
          setTimeout(() => {
            this.getTextSelectionProperties();
          });
        }
        newTargets.forEach((element) => {
          this.objectList.forEach((object) => {
            if (object.Id === element.id && object.IsVisible) {
              object.isSelected = true;
            }
          });
          this.setActiveObject();
        });
      },
    },
  },
  updated() {
    // document.querySelector('.rCS1w3zcxh  .moveable-area.moveable-pass').style.pointerEvents = 'all';
    this.$nextTick().then(() => {

    });
  },
  mounted() {
    if (!this.isFakeRendering) {
      this.$nextTick(this.bindClickEventToMoveableControls);
      this.isMounted = true;
      this.container = document.querySelector('#canvas-wrapper');
      this.initSelectManager();
      this.initMoveableManager();
      window.addEventListener('keydown', this.doCommand);
      window.addEventListener('resize', this.updateOnWindowResize);
      window.onresize =    this.moveableObj.updateRect();

      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DELETED, this.removeObjectFromCanvas);
      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.UPDATED, this.onObjectUpdated);
      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.SET_TARGET_EMPTY, this.setTargetEmpty);
      EventBus.$on(ApplicationEventTypes.TextObjectEvents.UPDATED, this.onUpdateTextProperties);
      EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_COLOR, this.changeShapeColor);
      EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_STROKE, this.changeShapeStroke);
      EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_STROKE_WIDTH, this.changeStrokeWidth);
      EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR, this.changeSvgFillColor);
      EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_STROKE_COLOR, this.changeSvgStrokeColor); EventBus.$on(ApplicationEventTypes.ImageObjectEvents.REPLACED, this.replaceCanvansPhoto);
      EventBus.$on(ApplicationEventTypes.ImageObjectEvents.REPLACED_ADDRESS_PHOTO, this.replaceCanvansAddressBoxPhoto);
      EventBus.$on(ApplicationEventTypes.ImageObjectEvents.CHANGE_FDIC_PHOTO, this.changeFdicPhoto);
      EventBus.$on(ApplicationEventTypes.ImageObjectEvents.CHANGE_HOUSING_PHOTO, this.changeHousingPhoto);
      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.SELECTED_FROM_RIGHT_PANEL, this.selectingCanvasObjectFromRightPanel);
      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.onClearSelection);
      EventBus.$on(ApplicationEventTypes.ImageObjectEvents.ADDED, this.AddNewObjectImage);
      EventBus.$on(ApplicationEventTypes.TextObjectEvents.TEXT_EDITOR_ADDED, this.addingTextEditor);
      EventBus.$on(ApplicationEventTypes.TextObjectEvents.TEXT_SELECTION_UPDATED, this.getTextSelectionProperties);
      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.ZOOM_CHANGE, this.onObjectUpdated);
      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.UPDATE_OBJECT_ALIGNMENT, this.alignObjectPosition);
      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.ROTATE_OBJECT, this.rotateObject);
      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.FLIP_OBJECT, this.flipObject);
      EventBus.$on(ApplicationEventTypes.AnimationEvent.SET_ELEMENT_ANIMATION, this.setElementAnimation);
      EventBus.$on(ApplicationEventTypes.Video.ADD_NEW_VIDEO_ON_CANVAS, this.AddNewObjectVideo);
      EventBus.$on(ApplicationEventTypes.Video.TRIM_VIDEO, this.trimVideo);
      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DUPLICATE, this.duplicateObject);
      EventBus.$on('deleteContentReq', this.deleteObject);

    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.doCommand);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR, this.changeSvgFillColor);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_STROKE_COLOR, this.changeSvgStrokeColor);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_STROKE_WIDTH, this.changeStrokeWidth);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DELETED, this.removeObjectFromCanvas);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.CHANGE_FDIC_PHOTO, this.changeFdicPhoto);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.CHANGE_HOUSING_PHOTO, this.changeHousingPhoto);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.SET_TARGET_EMPTY, this.setTargetEmpty);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.UPDATED, this.onObjectUpdated);
    EventBus.$off(ApplicationEventTypes.TextObjectEvents.UPDATED, this.onUpdateTextProperties);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.REPLACED, this.replaceCanvansPhoto);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.REPLACED_ADDRESS_PHOTO, this.replaceCanvansAddressBoxPhoto);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.SELECTED_FROM_RIGHT_PANEL, this.selectingCanvasObjectFromRightPanel);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.onClearSelection);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.ADDED, this.AddNewObjectImage);
    EventBus.$off(ApplicationEventTypes.TextObjectEvents.TEXT_EDITOR_ADDED, this.addingTextEditor);
    EventBus.$off(ApplicationEventTypes.TextObjectEvents.TEXT_SELECTION_UPDATED, this.getTextSelectionProperties);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_COLOR, this.changeShapeColor);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_STROKE, this.changeShapeStroke);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.ZOOM_CHANGE, this.onObjectUpdated);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.UPDATE_OBJECT_ALIGNMENT, this.alignObjectPosition);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.ROTATE_OBJECT, this.rotateObject);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.FLIP_OBJECT, this.flipObject);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.ROTATE_OBJECT, this.rotateObject);
    EventBus.$off(ApplicationEventTypes.AnimationEvent.SET_ELEMENT_ANIMATION, this.setElementAnimation);
    EventBus.$off(ApplicationEventTypes.Video.ADD_NEW_VIDEO_ON_CANVAS, this.AddNewObjectVideo);
    EventBus.$off(ApplicationEventTypes.Video.TRIM_VIDEO, this.trimVideo);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DUPLICATE, this.duplicateObject);
    EventBus.$off('deleteContentReq', this.deleteObject);
    this.removeClickEventToMoveableControls();

  },
  methods: {
    duplicateObject() {
      const selectedList = this.objectList.filter(element => element.isSelected == true);
      selectedList.reverse();
      selectedList.forEach((tempObj) => {
        const obj     = _.cloneDeep(tempObj);
        let nameExist = true;
        do {
          if (this.objectList.find(item => item.Name === obj.Name)) {
            obj.Name += ' copy';
          } else { nameExist = false; }
        } while (nameExist);
        obj.Id         = uuid.v1();
        obj.isSelected = false;
        obj.editor     = null;
        obj.PageNo     = this.getActivePageIndex;
        obj.type == 'text' && obj.modifiedHtml !== obj.Value && (obj.Value = obj.modifiedHtml);
        this.objectList.unshift(obj);
      });
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
      this.emitUndoRedoRequest('called by duplicateLayer');
    },
    deleteObject(objectIndex) {
      const toRemove             = [];
      let selectedElementDeleted = false;
      if (objectIndex === -1) {
        this.objectList.forEach((element, index) => {
          if (element.isSelected) {
            toRemove.push(index); if (element.isSelected) { selectedElementDeleted = true; }
          }
        });
      } else if (objectIndex > -1 && objectIndex < this.objectList.length) {
        toRemove.push(objectIndex);
      }
      for (let i = toRemove.length - 1; i >= 0; i--) {
        const removedElement = this.objectList.splice(toRemove[i], 1);
        if (removedElement.length > 0 && removedElement[0].isSelected) { selectedElementDeleted = true; }
      }

      if (selectedElementDeleted) { EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED); }
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
      this.emitUndoRedoRequest('called by delete');
    },
    pasteCopiedObjects() {
      const copiedObjects = _.cloneDeep(this.$store.getters.getCopiedObjects);
      copiedObjects.reverse();
      copiedObjects.forEach((obj) => {
        let nameExist = true;
        do {
          if (this.objectList.find(item => item.Name === obj.Name)) {
            obj.Name += ' copy';
          } else { nameExist = false; }
        } while (nameExist);
        obj.Id         = uuid.v1();
        obj.isSelected = false;
        obj.editor     = null;
        obj.PageNo     = this.getActivePageIndex;
        obj.type == 'text' && obj.modifiedHtml !== obj.Value && (obj.Value = obj.modifiedHtml);
        this.objectList.unshift(obj);
      });
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
      this.emitUndoRedoRequest('called by pasteCopiedObjects');
    },
    deleteCopiedLayers(copiedObjects) {
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      copiedObjects.forEach((copiedObj) => {
        const index = this.objectList.findIndex(layer => layer.Id === copiedObj.Id);
        if (index !== -1) {
          this.objectList.splice(index, 1);
        }
      });
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
      this.emitUndoRedoRequest('called by delete Copied Objects');
    },
    trimVideo({ startTime, endTime }) {
      this.activeObject.videoDetails.startTime = parseFloat(startTime);
      this.activeObject.videoDetails.endTime   = parseFloat(endTime);
      EventBus.$emit(ApplicationEventTypes.ProductPageEvents.ACTIVE_PAGE_DURATION_UPDATE);
    },
    updateOnWindowResize() {
      console.log('update canvas');
      setTimeout(() => {
        this.moveableObj.updateRect();
      });
    },
    updateMoveableTargets() {
      const { target } =  this.moveableObj;
      if (target && target.length > 0) {
        const object =   this.objectList[parseInt(target[0].dataset.elementindex, 10)];
        object && object.type === 'text' && (object.Value = object.modifiedHtml);
      }
      this.targets = [];
      if (this.activeObject) {
        const selectedItem = this.objectList.filter(elem => elem.isSelected);
        this.targets       = selectedItem.map(item => document.getElementById(item.Id));
      }
      this.moveableObj.target = this.targets;
      if (this.activeObject && this.activeObject.type === 'text') {
        setTimeout(() => {
          this.getTextSelectionProperties();
        });
      }
      setTimeout(() => {
        this.moveableObj.updateRect();
      }, 500);

    },
    rotateObject(direction) {
      if (direction == 1) { this.moveableObj.request('rotatable', { deltaRotate: 5 }, true); }
      if (direction == -1) { this.moveableObj.request('rotatable', { deltaRotate: -5 }, true); }

      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
      this.emitUndoRedoRequest('Called by rotate end');
    },
    flipObject(direction) {
      if (direction == 1) {
        if (this.activeObject.IsHFlipped == false) { this.activeObject.IsHFlipped = true; } else { this.activeObject.IsHFlipped = false; }
      }
      if (direction == -1) {
        if (this.activeObject.IsVFlipped == false) { this.activeObject.IsVFlipped = true; } else { this.activeObject.IsVFlipped = false; }
      }

      this.onObjectUpdated();
      this.emitUndoRedoRequest('called by Flip Update');
    },
    alignObjectPosition(param) {
      if (!this.activeObject) { return; }
      const objectElement   = document.getElementById(this.activeObject.Id).getBoundingClientRect();
      const mainHtmlElement = document.getElementById('main_html').getBoundingClientRect();
      const scale           = new DOMMatrix(document.getElementById('main_html').style.transform).m11;
      let diff              = 0;
      const { productCrop } = param;
      switch (param.value) {
        case 'left':
          // this.activeObjectForLeftPanel.X =  productCrop.AllowCropping ? Number(productCrop.XCrop) : 0;
          diff                 = Math.ceil((mainHtmlElement.left - objectElement.left) / scale);
          this.activeObject.X +=  productCrop.AllowCropping ? Number(productCrop.XCrop) + diff : diff;
          break;
        case 'center':
          this.activeObject.X = (this.width - this.activeObject.Width) / 2;
          break;
        case 'right':
          diff                 = parseFloat((mainHtmlElement.right - objectElement.right) / scale);
          this.activeObject.X +=  diff;
          break;
        case 'top':
          diff                 = parseFloat((mainHtmlElement.top - objectElement.top) / scale);
          this.activeObject.Y += productCrop.AllowCropping ? Number(productCrop.YCrop) + diff : diff;
          console.log('top is ', this.activeObject.Y);
          break;
        case 'middle':
          this.activeObject.Y = (this.height - this.activeObject.Height) / 2;
          break;
        case 'bottom':
          diff                 = parseFloat((mainHtmlElement.bottom - objectElement.bottom) / scale);
          this.activeObject.Y += diff;

          break;
        default:
          break;
      }
      this.$nextTick(() => {
        this.moveableObj.updateRect();
      });

      this.emitUndoRedoRequest('called by Position Update');
    },
    doCommand(e) {
      const focussedElement = document.activeElement;
      const tagName         = focussedElement.tagName.toLowerCase();
      if (tagName === 'textarea' || tagName === 'input') { return; }
      const isCtrlKey = e.metaKey || e.ctrlKey;
      if (isCtrlKey && !this.activeEditor) {
        switch (e.keyCode) {
          case 89:
            EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.PRODUCT_UPDATED, 'redo');
            e.preventDefault();
            break;
          case 90:
            EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.PRODUCT_UPDATED, 'undo');
            e.preventDefault();
            break;
          case 86:
            this.pasteCopiedObjects();
            e.preventDefault();
            break;
          case 67:
            this.copyByKey('copy');
            e.preventDefault();
            break;
          case 88:
            this.copyByKey('cut');
            e.preventDefault();
            break;
          case 65:
            this.selectAll();
            e.preventDefault();
            break;
          default:
            break;
        }
      }
      if (!this.activeObject || this.$store.getters.getDisplayQRCodeModal || this.activeEditor) {
        return;
      }
      const delta = Math.ceil(this.$store.getters.getZoomLevel / 100);
      switch (e.keyCode) {
        case 37:
          this.moveableObj.request('draggable', { deltaX: -delta, deltaY: 0 }, true);
          e.preventDefault();
          break;
        case 38:
          this.moveableObj.request('draggable', { deltaX: 0, deltaY: -delta }, true);
          e.preventDefault();
          break;
        case 39:
          this.moveableObj.request('draggable', { deltaX: delta, deltaY: 0 }, true);
          e.preventDefault();
          break;
        case 40:
          this.moveableObj.request('draggable', { deltaX: 0, deltaY: delta }, true);
          e.preventDefault();
          break;
        case 46:
        case 8:
          EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, {
            request: 'DeleteReq',
            data:    -1,
            message: 'Are you sure you want to delete selected element(s)?',
            isVideo: true,
          });
          e.preventDefault();
          break;
        default:
          break;
      }
    },
    selectAll() {
      this.onClearSelection();
      this.objectList.forEach((item) => {
        item.isSelected = true;
      });
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
      this.$nextTick(() => {
        const elements =    [];
        this.objectList.forEach((item) => {
          if (!item.locked) { elements.push(document.getElementById(item.Id)); }
        });
        this.selectO.setSelectedTargets(elements);
        const clickEvent = new MouseEvent('click', {
          view:       window,
          bubbles:    true,
          cancelable: true,

        });

        this.selectO.trigger('selectEnd', {
          inputEvent:  clickEvent,
          selected:    elements,
          isDragStart: false,
          removed:     [],
        });
      });
    },
    copyByKey(action) {
      const tempArray  = [];
      const { target } =  this.moveableObj;
      if (target && target.length > 0) {
        this.moveableObj.target.forEach((target) => {
          tempArray.push(_.cloneDeep(this.objectList[target.dataset.elementindex]));
        });
        this.$store.commit('updateCopiedObjects', tempArray);
        if (action === 'cut') {
          this.deleteCopiedLayers(tempArray);
        }
      }
    },
    setTargetEmpty() {
      this.targets = [];
    },
    onCanvasDoubleClick() {
      // this.targets && this.targets.length === 1 && this.targets[0].dataset.type === 'text' && this.setupActiveEditor(this.targets[0]);
      this.activeObject && this.activeObject.type === 'text' && this.setupActiveEditor();
    },

    onCanvasClick(e) {
      e.stopPropagation();
    },
    setElementAnimation(payload) {
      this.activeObject.animation          = {};
      this.activeObject.animation.style    = payload.animation.style ? payload.animation.style : '';
      this.activeObject.animation.speed    = payload.animation.speed ? payload.animation.speed : 50;
      this.activeObject.animation.onEnter  = payload.animation.onEnter ? payload.animation.onEnter : false;
      this.activeObject.animation.onExit   = payload.animation.onExit ? payload.animation.onExit : false;
      this.activeObject.animation.distance = payload.animation.distance ? payload.animation.distance : 50;
      this.activeObject.isAnimated         = payload.isAnimated;
    },
  },
};

</script>

<style lang="scss">
  .selection-icons{
    z-index: 9999999;
    .bm-small-btns{
      box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
    }
  }
  .rCS1w3zcxh  {
    .moveable-line {
      background: transparent !important;
      border: 1px dashed #3BB0FA !important;
      //left: -5px !important ;
    }
    .moveable-area{
      &.moveable-pass{
        pointer-events: var(--moveable-pointer-events) !important;
      }
    }

    .moveable-control {
      background: $white !important;
      border: 2px solid $blue50 !important;

      &.moveable-e {
        height: 60px;
        width: 8px;
        border-radius: 4px;
        left: 3px !important;
        top: -23px;
        opacity: var(--moveable-ew-opacity);
        z-index: 9;
      }

      &.moveable-n {
        height: 8px;
        width: 60px;
        border-radius: 4px;
        left: -23px;
        top: 3px;
        opacity: var(--moveable-ns-opacity);
        z-index: 9;
      }

      &.moveable-w {
        height: 60px;
        width: 8px;
        border-radius: 4px;
        left: 3px;
        top: -23px;
        opacity: var(--moveable-ew-opacity);
        z-index: 9;
      }

      &.moveable-s {
        height: 8px;
        width: 60px;
        border-radius: 4px;
        left: -23px;
        top: 3px;
        opacity: var(--moveable-ns-opacity);
        z-index: 9;
      }

      .moveable-line {
        height: 1.5px !important;

      }

      .moveable-rotation-line {
        height: 100% !important;
        width: 1.5px !important;
      }
    }
  }

    .canvas-main-html-container {
      svg {
        width: auto !important;
        height: auto !important;
      }
    }

    .moveable-dragging {
      cursor: url('../../assets/images/active-selction.png'), auto !important;
    }
  .extended-button{
      width:           36px;
      height:          36px;
      padding:         0px;
      background-color: white;
      border-radius:    5px;
      border:          1px solid #ededed;
      cursor:          pointer  !important;
    font-family: fontAwesome;
    font-size: 14px;
    color: #7a7777;
    box-shadow: 4px 3px 7px 0px #808080a6;
      &.delete-button{
        &:before{
          content: "\F1F8";
        }
      }
    &.duplicate-button{
      &:before{
        content: "\f24d";
      }
    }
    &.drag-button{
      &:before{
        content: "\f047";
      }
    }
    &.crop-button{
      &:before{
        content: "\f125";
      }
    }
  }

  .dimension-viewer{
    background: $blue50;
    border: none;
    color: white;
    font-family: monospace;
    font-size: 12px;
    white-space: nowrap;
    border-radius: 2px;
    padding: 2px 5px;
    line-height: 11px;
  }

</style>
